import React from "react";
import { Essay } from "./Types";
import { Link } from "react-router-dom";

export default function (props: {
    essays: Array<Essay>;
    // setEssay: (essay: Essay) => void;
    activeSlug?: string;
}) {

    return (
        <div className="EssayMenu">
            {props.essays.map((essay: Essay, i: number) => {

                return (
                    <Link
                        to={`/essays/${essay.slug}`}
                        key={`${essay.slug}-${i}`}>
                        <div
                            className={`item ${props.activeSlug === essay.slug ? "active" : "inactive"}`}>
                            {essay.title}
                        </div>
                    </Link>
                )
            })}
        </div>
    )
}